import * as Sentry from '@sentry/react';
import { ApiError } from '@/lib/api';

export type SentryReportContext = {
  source?: 'query' | 'mutation';
  queryKey?: unknown;
  mutationKey?: unknown;
};

const CLIENT_VALIDATION_PATTERNS = [
  /^Please enter /i,
  /^Please select /i,
  /^No household found/i,
  /^User not ready/i,
  /^No co-parent found/i,
];

export function shouldReportError(err: unknown): boolean {
  if (err instanceof ApiError) {
    if (err.status >= 400 && err.status < 500) {
      return false;
    }
    return true;
  }

  if (err instanceof Error) {
    const message = err.message.trim();
    if (CLIENT_VALIDATION_PATTERNS.some((pattern) => pattern.test(message))) {
      return false;
    }
  }

  return true;
}

export function reportError(err: unknown, context?: SentryReportContext): void {
  if (!shouldReportError(err)) {
    return;
  }

  Sentry.captureException(err, {
    extra: context,
    tags: context?.source ? { source: context.source } : undefined,
  });
}
